// this is the contents of the competition.coupons AWSJSON column. DO NOT CHANGE!
export const couponsColumns  = [
  {
    title: 'Coupon',
    key: 'coupon'
  },
  {
    title: 'Discount %',
    key: 'discount'
  }
];

export const couponsRows = 3;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/awsjson.coupons.js